import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from './utils/http';
import AMap from 'vue-amap';
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard)
Vue.use(ElementUI);
Vue.use(AMap)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
axios.defaults.baseURL  =  process.env.VUE_APP_URL;
AMap.initAMapApiLoader({
        key: 'a32b106544f3de428245a79c9210dc4f',
        plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
        v: '1.4.4',
        uiVersion: '1.0',
    })
    // vue原型挂载 - 是否PC端
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    Vue.prototype.$pc = false
} else {
    Vue.prototype.$pc = true
}
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')